var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5586 3.80859C18.9023 3.80859 15.4898 4.85859 12.6211 6.65859L25.4836 19.5398L25.5024 14.4023C25.5024 13.6336 26.1399 12.9961 26.9086 12.9961C27.6961 12.9961 28.3149 13.6336 28.3149 14.4023L28.2961 22.9336C28.2961 23.5148 27.9399 24.0211 27.4149 24.2274C27.2461 24.3024 27.0586 24.3398 26.8899 24.3398C26.5149 24.3398 26.1586 24.1899 25.8961 23.9274L10.5398 8.55235C10.4648 8.47734 10.4086 8.40235 10.3523 8.32735C6.33984 11.7773 3.80859 16.8773 3.80859 22.5586C3.80859 32.9086 12.2086 41.3086 22.5586 41.3086C26.2149 41.3086 29.6274 40.2586 32.4961 38.4586L19.6336 25.5774L19.6148 30.7149C19.6148 31.4836 18.9773 32.1211 18.2086 32.1211C17.4211 32.1211 16.8023 31.4836 16.8023 30.7149L16.8211 22.1836C16.8211 21.6024 17.1773 21.0961 17.7023 20.8899C18.2086 20.6649 18.8273 20.7773 19.2211 21.1898L34.5774 36.5649C34.6524 36.6399 34.7086 36.7149 34.7649 36.7899C38.7774 33.3399 41.3086 28.2399 41.3086 22.5586C41.3086 12.2086 32.9086 3.80859 22.5586 3.80859Z",
    fill: "#FFDEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.25dd3bf9d2199469634ad150a1c5a1e0.svg";
export { ForwardRef as ReactComponent };